import { Inject, Injectable, forwardRef } from '@angular/core';

import { ApiOptionsModel }            from './models/api.options';
import { ApiService }              from './api.service';
import { VerboseStreamResponseModel } from './models/stream.verbose-response';

@Injectable({
  providedIn: 'root'
})
export class StreamSearchService {
  constructor (
    @Inject(forwardRef(() => ApiService)) private apiService: ApiService
  ) {}

  search ( category : string, typed : string , options ?: ApiOptionsModel ) : any {
    return this.apiService.stream('searches', [ typed, category ], options);
  }
}